import { ReturnActionType } from "../types/return-type";
import { TokenKeyActionTypes } from "../types/token";

export const addToken = (payload: string): ReturnActionType => ({
  type: TokenKeyActionTypes.ADD_TOKEN_KEY,
  payload,
});
